<ng-template #labelTemplate>
  <label *ngIf="props.label && props.hideLabel !== true"
         [attr.for]="id"
         class="form-label me-2">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true"
          class="text-danger">*</span>
  </label>
</ng-template>
<div *ngIf="!props.hidden"
     [class.form-floating]="props.labelPosition === 'floating'"
     [class.has-error]="showError"
     [class.is-invalid]="showError">

  <ng-container *ngIf="props.labelPosition !== 'floating'">
    <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
  </ng-container>

  <ng-template #fieldComponent></ng-template>

  <ng-container *ngIf="props.labelPosition === 'floating'">
    <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
  </ng-container>

  <div *ngIf="showError"
       class="invalid-feedback"
       [style.display]="'block'">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>

  <small *ngIf="props.description"
         class="form-text text-muted">{{ props.description }}</small>
</div>